import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Label,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { canUserManageShare } from '../../helpers/Share';
import { userHasFeature } from '../../helpers/Features';

import { showModalTop } from '../../actions';

import HelpIcon from '../HelpIcon';
import UpgradePlanButton from '../UpgradePlanButton';

const ShareModalLogo = ({
  handleChange,
  handleChangeLogoUrl,
  openModal,
  logo,
  logoUrl,
  client,
  small,
}) => {
  const canManageShare = canUserManageShare();
  const defaultShareLogo = (client && client.share_logo_url) || '/logo/share';
  const currentLogoSrc = logoUrl || logo || defaultShareLogo;

  const intl = useIntl();

  return (
    <div className="share-logo share-setting form-inline">
      <Label>
        <span>
          {intl.formatMessage({ defaultMessage: 'Logo' })}
          <HelpIcon id="share-logo">
            {intl.formatMessage({ defaultMessage: 'Set a logo for share.' })}
          </HelpIcon>
        </span>
      </Label>
      <div>
        <UpgradePlanButton feature="share-custom-branding" simple={true} />
        <div className="image-container small-logo-container">
          <div className="image-wrapper">
            <img key={currentLogoSrc || 'default-share-logo'} src={currentLogoSrc} alt={intl.formatMessage({ defaultMessage: 'Selected file' })} id="ShareLogoImg" />
          </div>
        </div>
        {(canManageShare && userHasFeature('share-custom-branding')) && (
          <>
            <Button
              color="primary"
              onClick={() => openModal({
                handleSelectFile: (logoPath) => {
                  handleChange(logoPath);
                },
                handleFileUrl: (url) => {
                  handleChangeLogoUrl(url || null);
                },
                className: 'modal-select-file modal-select-file-enhanced',
              })}
              size={small ? 'sm' : 'md'}
            >
              <i className="far fa-random" />
              {intl.formatMessage({ defaultMessage: 'Change' })}
            </Button>
            <Button
              color="secondary"
              onClick={() => {
                handleChange(null);
                handleChangeLogoUrl(null);
              }}
              size={small ? 'sm' : 'md'}
            >
              <i className="far fa-times" />
              {intl.formatMessage({ defaultMessage: 'Remove' })}
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  workspaceColor: state.App.settings.color,
  client: state.Auth.profile?.client,
});

const mapDispatchToProps = dispatch => ({
  openModal: (params) => {
    dispatch(showModalTop('FileSelectModalEnhanced', params));
  },
});

ShareModalLogo.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleChangeLogoUrl: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  client: PropTypes.object.isRequired,
  logo: PropTypes.string,
  logoUrl: PropTypes.string,
  small: PropTypes.bool,
};

ShareModalLogo.defaultProps = {
  logo: null,
  logoUrl: null,
  small: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareModalLogo);
